import styles from '@/components/Courses/CourseCard/CourseCard.module.scss'
import Checkbox from 'antd/lib/checkbox'
import {
    AccessType,
    ACCESS_TYPE_TO_PRETTY_NAME,
} from 'common/src/api/websiteFrontendVsWebsiteBackend/accountMaintenance/types'
import React, { ReactElement } from 'react'

const getPriceString = (
    accessType: AccessType,
    accessTypesPurchased: AccessType[],
    pricePerAccessType: number
): string => {
    if (accessTypesPurchased.includes(accessType)) {
        return 'PURCHASED'
    }

    return `$${pricePerAccessType}`
}

interface CourseCardItemProps {
    accessType: AccessType
    accessTypesToPurchase: AccessType[]
    accessTypesPurchased: AccessType[]
    setAccessTypesToPurchase: (accessTypes: AccessType[]) => void
    costPerAccessType: number
    bulletItems: ReactElement
}

export const CourseCardItem: React.FC<CourseCardItemProps> = (
    props
): ReactElement => {
    return (
        <>
            <div className={styles.bulletHeader}>
                <div>
                    <Checkbox
                        checked={
                            props.accessTypesToPurchase.includes(
                                props.accessType
                            ) ||
                            props.accessTypesPurchased.includes(
                                props.accessType
                            )
                        }
                        disabled={props.accessTypesPurchased.includes(
                            props.accessType
                        )}
                        className={styles.checkbox}
                        onClick={() =>
                            props.accessTypesToPurchase.includes(
                                props.accessType
                            )
                                ? props.setAccessTypesToPurchase(
                                      props.accessTypesToPurchase.filter(
                                          (accessType) =>
                                              accessType !== props.accessType
                                      )
                                  )
                                : props.setAccessTypesToPurchase([
                                      ...props.accessTypesToPurchase,
                                      props.accessType,
                                  ])
                        }
                    />
                    <b>{ACCESS_TYPE_TO_PRETTY_NAME[props.accessType]}</b>
                </div>
                <div
                    className={`${styles.price} ${
                        props.accessTypesToPurchase.includes(
                            props.accessType
                        ) ||
                        props.accessTypesPurchased.includes(props.accessType)
                            ? ''
                            : styles.disabled
                    }`}
                >
                    {getPriceString(
                        props.accessType,
                        props.accessTypesPurchased,
                        props.costPerAccessType
                    )}
                </div>
            </div>
            {props.bulletItems}
        </>
    )
}
